<div class="heading-widget d-flex flex-column align-items-start">
    @if (label) {
    <span class="label-text text-muted mb-1">{{label}}</span>
    }
    <div class="heading-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
        <h2 class="heading-name fw-bold m-0 text-break">{{heading}}</h2>
    </div>
    @if (footer) {
    <span class="footer-text text-muted small">{{footer}}</span>
    }
</div>